import React from 'react';

const Icon = ({ icon, solid, regular, light, brand }) => (<i className={`${(solid || (!regular && !light && !brand)) ? 'fas' : '' }${light ? 'fal' : '' }${regular ? 'far' : '' }${brand ? 'fab' : '' } fa-${icon}`} />);

export default Icon;
